import './App.css'
import './mediaQueries.css'
import Arbiter from './components/Arbiter/Arbiter'

// The app component
function App() {
  return (
    <div id='app'>
      <Arbiter />
    </div>
  )
}

export default App
